const getElementFromArray = (array, el) => {
  const isThereElement = array.indexOf(el);

  return isThereElement;
}

export default getElementFromArray;